import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useUpdateEffect } from '@cian/react-utils';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { useSlideContext } from '../../../../utils/slideContext';
import { useSliderContext } from '../../../../utils/sliderContext';
import styles from './AutoZoomContainer.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var AutoZoomContainer = function AutoZoomContainer(_ref) {
  var children = _ref.children,
      childRef = _ref.childRef;

  var _useSliderContext = useSliderContext(),
      _useSliderContext$aut = _useSliderContext.autoZoomSettings,
      autoZoomSettings = _useSliderContext$aut === void 0 ? {} : _useSliderContext$aut,
      currentSlide = _useSliderContext.currentSlide,
      autoZoom = _useSliderContext.autoZoom;

  var _autoZoomSettings$del = autoZoomSettings.delay,
      delay = _autoZoomSettings$del === void 0 ? 500 : _autoZoomSettings$del,
      _autoZoomSettings$dur = autoZoomSettings.duration,
      duration = _autoZoomSettings$dur === void 0 ? 5000 : _autoZoomSettings$dur;

  var _useSlideContext = useSlideContext(),
      isSlideActive = _useSlideContext.isActive;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAutoZooming = _React$useState2[0],
      setIsAutoZooming = _React$useState2[1];

  var _React$useState3 = React.useState(currentSlide),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      lastActiveSlide = _React$useState4[0],
      setLastActiveSlide = _React$useState4[1];
  /** Запускаем автозум */


  React.useEffect(function () {
    if (!autoZoom || !isSlideActive) {
      return;
    }

    var timer = setTimeout(function () {
      setIsAutoZooming(true);
      setLastActiveSlide(currentSlide);
    }, delay);
    return function () {
      return clearTimeout(timer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, autoZoom]);
  /** Сбрасываем активный автозум при переключении слайда */

  useUpdateEffect(function () {
    if (currentSlide === lastActiveSlide || !isAutoZooming) {
      return;
    }

    setTimeout(function () {
      setIsAutoZooming(false);
    }, 300);
  }, [currentSlide, isAutoZooming, lastActiveSlide]);
  /** Резко сбрасываем автозум, если автозум отключается */

  useUpdateEffect(function () {
    if (autoZoom || !isAutoZooming) {
      return;
    }

    setIsAutoZooming(false);
  }, [autoZoom]);
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: isAutoZooming,
    timeout: duration,
    classNames: {
      enter: styles['enter'],
      enterActive: styles['enter-active'],
      enterDone: styles['enter-done'],
      exit: styles['exit']
    },
    nodeRef: childRef,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['container'],
      children: children
    })
  });
};